import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const activeFiltersRowClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.md,
  flexWrap: 'wrap',
  marginBottom: spacingVars.lg,
});

export const clearFiltersButtonClass = style({
  flexShrink: 0,
  whiteSpace: 'nowrap',
});

export const visuallyHiddenClass = style({
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
});
